// TODO: Unify all Display Mode buttons into common component
import { Grid } from '@material-ui/core';
import React from 'react';
import BaseButton from 'src/common/components/base-button';
import { styles } from './display-mode-button-styles';

interface DisplayButtonProps {
  icon: JSX.Element;
  selected: boolean;
  disabled?: boolean;
}
const DisplayButton = ({ icon, selected, disabled }: DisplayButtonProps): JSX.Element => {
  const classes = styles({ selected });
  return (
    <Grid item>
      <BaseButton
        isSquare
        buttonType={selected ? 'white' : 'alternate'}
        className={classes.displayModeButton}
        disabled={disabled}
      >
        {icon}
      </BaseButton>
    </Grid>
  );
};

export default DisplayButton;
